function getColorStr(color: string) {
  return /#/.test(color) ? color : `#${color}`;
}

export { getColorStr };
